/*
  gcseo.js — copy-to-clipboard for the official coupon codes on /pages/coupons.
  Progressive: every code is already visible and selectable as text (user-select:all),
  so with this script blocked nothing is lost. One delegated listener, no dependencies.
  Fires a dataLayer event (gcseo_copy_code) so GA4/GTM can count copies per code.
*/
(function () {
  if (window.__gcseoCopy) return;
  window.__gcseoCopy = true;

  function fallbackCopy(text) {
    var ta = document.createElement('textarea');
    ta.value = text;
    ta.setAttribute('readonly', '');
    ta.style.position = 'fixed';
    ta.style.top = '-1000px';
    document.body.appendChild(ta);
    ta.select();
    var ok = false;
    try { ok = document.execCommand('copy'); } catch (e) { ok = false; }
    document.body.removeChild(ta);
    return ok ? Promise.resolve() : Promise.reject();
  }

  function copy(text) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text).catch(function () { return fallbackCopy(text); });
    }
    return fallbackCopy(text);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-gcseo-copy]') : null;
    if (!btn) return;
    e.preventDefault();
    var code = btn.getAttribute('data-gcseo-copy') || '';
    var label = btn.getAttribute('data-label') || btn.textContent;
    var done = btn.getAttribute('data-done') || 'Copied';
    var live = document.getElementById(btn.getAttribute('aria-describedby') || '');
    copy(code).then(function () {
      btn.textContent = done;
      if (live) live.textContent = done + ': ' + code;
      setTimeout(function () { btn.textContent = label; }, 2200);
    }, function () {
      var box = btn.parentNode && btn.parentNode.querySelector('.gcseo-code__box');
      if (box && window.getSelection) {
        var r = document.createRange();
        r.selectNodeContents(box);
        var sel = window.getSelection();
        sel.removeAllRanges();
        sel.addRange(r);
      }
    });
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'gcseo_copy_code', coupon_code: code, page_path: location.pathname });
    } catch (err) {}
  });
})();
